import {createStore} from 'vuex'
import {auth} from './auth.module';
import {incidents} from './incidents.module';
import {dashboard} from './widgets.module';

export const store = createStore({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        incidents,
        dashboard,
    }
});
